/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import passwordPolicy from './PasswordPolicy';

export const validatePassword = (password: string, values: GenericObject): Function | undefined => {
  const {isValid, validate} = passwordPolicy(values.username, values.groupName, values?.config);
  if (!isValid(password)) {
    return validate(password);
  }
};
